import script from "./ResultsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultsPage.vue?vue&type=script&setup=true&lang=js"

import "./ResultsPage.vue?vue&type=style&index=0&id=037dcebd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-037dcebd"]])

export default __exports__